// extracted by mini-css-extract-plugin
export default {"container":"appVersionSettings_container__-V-KT","linksWrapper":"appVersionSettings_linksWrapper__GVCZR","linkWrapper":"appVersionSettings_linkWrapper__3T8oD"};